export const portfoliosAuditEvents = {
    detailsOpened: `Portfolio Details Opened`,
    create: `Portfolio Created`,
} as const;
